module.exports = __webpack_public_path__ + "static/paymentOrchestIndex_en-b93725cdb996d0faa8c2e3993a2ece18.png";